import { IconLoader } from "@tabler/icons-react";

export const Loader = () => {
  return (
    <div className="grid place-content-center h-[90svh]">
      <div>
        <IconLoader size={56} className="animate-spin " />
        <p className="text-gray-500">Loading...</p>
      </div>
    </div>
  );
};
